import { t } from "@lingui/macro";
import {
	Checkbox,
	CheckboxProps,
	Form,
	FormInstance,
	Input,
	InputNumber,
	Select,
	Space,
} from "antd";
import { FC, useEffect, useState } from "react";
import { translate } from "utils";
import {
	BENEFIT_CODE,
	SubscriptionBenefit,
	SubscriptionBenefitConfig,
	SubscriptionBenefitConfigs,
	SubscriptionPackage,
} from "../type";

interface BenefitItemProps {
	data: SubscriptionBenefitConfig;
	index: number;
	form: FormInstance<SubscriptionPackage>;
}
const BenefitItem: FC<BenefitItemProps> = ({ data, index, form }) => {
	const [disabledQuota, setDisabledQuota] = useState(false);
	const [isChecked, setIsChecked] = useState(false);
	useEffect(() => {
		const benefit: SubscriptionBenefit =
			form.getFieldValue("benefits")?.[index];
		data.code === BENEFIT_CODE.CAR_PORT &&
			setDisabledQuota(benefit?.unlimited || false);
		form.setFieldValue(["benefits", index, "code"], data.code);
		form.setFieldValue(["benefits", index, "type"], data.type);
		setIsChecked(benefit?.checked ?? false);
	}, [form.getFieldValue("benefits")?.[index]]);

	const handelSelectChanged = (value: boolean) => {
		form.setFieldValue(["benefits", index, "unlimited"], value);
		setDisabledQuota(value);
	};
	const handelCheckBoxChanged: CheckboxProps["onChange"] = e => {
		form.setFieldValue(["benefits", index, "checked"], e.target.checked);
		setIsChecked(e.target.checked);
	};

	return (
		<Space className="w-full flex items-center flex-wrap">
			<Form.Item className="hidden" name={["benefits", index, "code"]}>
				<Input type="hidden" value={data.code} />
			</Form.Item>
			<Form.Item className="hidden" name={["benefits", index, "type"]}>
				<Input type="hidden" value={data.type} />
			</Form.Item>
			<Form.Item name={["benefits", index, "checked"]} valuePropName="checked">
				<Checkbox onChange={handelCheckBoxChanged} value={isChecked} />
			</Form.Item>
			{data.limit ? (
				<Form.Item label="" name={["benefits", index, "unlimited"]}>
					<Select
						className="w-32"
						options={[
							{ label: t`Unlimited`, value: true },
							{ label: t`Limit`, value: false },
						]}
						onChange={handelSelectChanged}
					/>
				</Form.Item>
			) : null}
			{data.quota && !disabledQuota ? (
				<Form.Item label={t`Quotation`} name={["benefits", index, "quota"]}>
					<InputNumber min={0} />
				</Form.Item>
			) : null}
			{translate(data.code)}

			{data.duration ? (
				<>
					<Form.Item
						label={t`Date`}
						name={["benefits", index, "duration"]}
						getValueFromEvent={value => {
							const parsedValue = parseInt(value, 10);
							return isNaN(parsedValue) ? 0 : Math.max(parsedValue, 0);
						}}
					>
						<InputNumber />
					</Form.Item>
					<Select
						className="w-32"
						value={1}
						options={[{ value: 1, label: t`Date` }]}
					/>
				</>
			) : null}
		</Space>
	);
};
interface BenefitsProps {
	form: FormInstance<SubscriptionPackage>;
}
const Benefits: FC<BenefitsProps> = ({ form }) => {
	return (
		<div className="shadow-lg px-5 pt-5 pb-10 bg-white p-5 w-full">
			<div className="mt-3 flex justify-between mb-4">
				<label className="font-semibold text-lg">{t`Benefits`}</label>
			</div>
			<div className="w-full space-y-5">
				{Object.keys(SubscriptionBenefitConfigs)?.map((key, index) => (
					<BenefitItem
						data={SubscriptionBenefitConfigs[key]}
						index={index}
						key={index}
						form={form}
					/>
				))}
			</div>
		</div>
	);
};

export default Benefits;
